import { render } from "./PdfDataSectionSummary.vue?vue&type=template&id=319793f2&scoped=true&ts=true"
import script from "./PdfDataSectionSummary.vue?vue&type=script&lang=ts"
export * from "./PdfDataSectionSummary.vue?vue&type=script&lang=ts"

import "./PdfDataSectionSummary.vue?vue&type=style&index=0&id=319793f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319793f2"]])

export default __exports__